var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{domProps:{"textContent":_vm._s(_vm.label)}}),_c('editor',{attrs:{"id":_vm.editorId,"api-key":'l2kditken5n9bjvnapr1o00vdwe2lbn6pugjmi0hradmz5z9',"init":{
      height: 500,
      menubar: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime image imagetools table paste code help wordcount fontsizes'
      ],
      toolbar:
        'undo redo | formatselect | fontsizeselect | bold italic forecolor backcolor | table | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | image | imagetools link',
      contextmenu: 'undo redo link image table copy paste',
      automatic_uploads: true,
      image_title: true,
      relative_urls : false,
      remove_script_host : false,
      convert_urls : true,
      images_upload_handler: _vm.handleImageUpload,
      file_picker_types: 'image',
      fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 24px 36px',
      extended_valid_elements: 'a[href|target|rel]',
      rel_list: [
        {title: 'None', value: ''},
        {title: 'No follow', value: 'nofollow'},
        {title: 'No index', value: 'noindex'},
        {title: 'No follow, No index', value: 'nofollow noindex'} ],
    }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),(_vm.error)?_c('p',{staticClass:"text-danger",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }